import React, { Component } from 'react';
import { Route } from 'react-router-dom';

import List from './List';

class Container extends Component {
  render() {
    return (
      <div id="featured">
        <Route exact path="/featured" component={List} />
      </div>
    );
  }
}

export default Container;
